import React, { useState } from 'react';
import { Button, Form, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Component that displays the onboarding form on the Connect Page

/* takes in users, roles (arrays tracking onboarding user addresses and their roles)
 as well as their state setting functions: setUsers, setRoles */

function OnboardingForm({ address, users, roles, lockboxFactory, setUsers, setRoles, phase2, setPhase2 }) {

  // state to track user/role pairs being inputted in the form
  const [inputFields, setInputFields] = useState([{ address: "", role: "" }]);
  const [lockboxAddr1, setLockboxAddr1] = useState("");
  
  // to toggle phases of the onboarding process
  const [phase, setPhase] = useState(phase2);

  // to hold buttons while the blockchain/MetaMask is processing
  const [processingHold, setProcessingHold] = useState(false);

  // used to handle changes to input fields for new users/roles
  const handleUserChange = (event, index) => {
    let data = [...inputFields];

    // pull the object at index
    // event.target.name is either address or role, set data[index][address OR role] = value specified by form
    data[index][event.target.name] = event.target.value;
    setInputFields(data);
  }

  // called when adding a new user pair to the onboarding form
  const addUsers = () => {
    let object = {
      address: "",
      role: ""
    }

    setInputFields([...inputFields, object]);
  }

  // called when removing a user pair from the onboarding form
  const removeUsers = (index) => {
    let data = [...inputFields];
    data.splice(index, 1)
    setInputFields(data);
  }

  // updates the users and roles states that have been passed down from ConnectPage
  const onboardingIsValid = () => {

    // to check if any user/role is empty
    var isEmpty = false;

    // to check if any address is duplicated
    var isDuplicate = null;

    // leaving the first one all empty should be fine
    if (inputFields.length == 1 && inputFields[0].address == "" && inputFields[0].role == "") {
      return true;
    }

    for (var user in inputFields) {

      // check if this input field is empty
      if (inputFields[user].address == "" || inputFields[user].role == "") {
        isEmpty = true;
        setUsers([]);
        setRoles([]);
        break;
      }

      // check if this input address is a duplicate
      if (users.includes(inputFields[user].address)) {
        isDuplicate = user;
        setUsers([]);
        setRoles([]);
        break;
      }

      // append this user address to users state
      users.push(inputFields[user].address);

      // append the corresponding user role to roles state
      if (inputFields[user].role == "admin") {
        roles.push(2);
      }
      else {
        roles.push(1);
      }
    }

    if (isEmpty) {
      alert("Not all fields correctly entered.");
      return false;
    }
    if (isDuplicate) {
      var temp = parseInt(isDuplicate);
      temp += 1;
      alert("Onboarded member number " + temp + " is a duplicate address.");
      return false;
    }
    return true;
  }

  const handleCreateLockbox = async () => {
    setProcessingHold(true);
    // validate input
    if (!onboardingIsValid()) {
      setProcessingHold(false);
      return;
    }
    try {
      // create Lockbox with initial users
      await lockboxFactory.methods.createLockbox(users, roles).send({ from: address });
      let allBoxes = await lockboxFactory.methods.getUserLockboxes(address).call();
      setLockboxAddr1(allBoxes[allBoxes.length - 1]);
      setPhase(false);
    } catch (error) {
      console.log(error)
    }
    setProcessingHold(false);
  };

  return (
    <div>
      {
        phase ?
        <div>
          <br />
            <h4>Add Initial Users:</h4>
            <h6>Your address is automatically added; feel free to add more users to this Lockbox here.</h6>
            <p>Note that you can choose to ignore this and onboard users later.</p>
            <Form>
              {inputFields.map((user, index) => {
                return (
                  <Row className="mb-3 d-flex align-items-end" key={index}>
                    <Form.Group as={Col} sm={6}>
                      <Form.Control type="text" name="address" placeholder="User Address" onChange={event => handleUserChange(event, index)} value={user.address} />
                    </Form.Group>

                    <Form.Group as={Col}>
                      <Form.Select name="role" defaultValue="default" onChange={event => handleUserChange(event, index)}>
                        <option value="default" disabled>Select a Role</option>
                        <option value="admin">Admin</option>
                        <option value="member">Member</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group as={Col} controlId="formButton">
                      <Button variant="outline-danger" onClick={() => removeUsers(index)}>Remove</Button>
                    </Form.Group>
                  </Row>
                )
              })}
            </Form>
            <Button variant="outline-success" onClick={addUsers}>Add Another User</Button>
            <br />
            <br />
            <br />
            <Button variant="dark" onClick={handleCreateLockbox} disabled={!address.includes('0x') || processingHold}>
              Create Lockbox
            </Button>
        </div>
        : 
        <Link id="create-launch-link" to="/app" state={{ lockboxAddr: lockboxAddr1 }}>
          <Button variant="dark" disabled={lockboxAddr1 == ""}>
            Launch App
          </Button>
        </Link>
      }
      </div>
  );


}

export default OnboardingForm;
